// extracted by mini-css-extract-plugin
module.exports = {"detail_section":"talent-finder-detail_detail_section__2Yasy"};